export default function LoadingSpinner() {
  return (
    <div className="flex items-center justify-center w-full h-[80vh]">
      <div className="w-16 h-16 border-t-4 border-orange-500 border-solid rounded-full animate-spin"></div>
    </div>
  );
}
